// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7eead04d] .selectedData{border:1px solid #e1e1e1;border-radius:19px;color:#080707;margin-right:8px;background-color:#f5f5f5}[data-v-7eead04d] .selectedData .el-tag__close{color:#888!important}[data-v-7eead04d] .selectedData .el-tag__close:hover{color:#888!important;background:#fff}", ""]);
// Exports
module.exports = exports;
